// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"cc92dcf1","88":"3370ebe5","296":"9647a187","487":"6c31404f","557":"1f487234","695":"447fd06a","770":"c2dbc286","854":"42524f60","883":"40722d84","920":"3be759da"}[chunkId] + ".chunk.js";
};